(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JoinVideoMeetingComponentController', JoinVideoMeetingComponentController);

    function JoinVideoMeetingComponentController($scope, $state, $stateParams, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, entity, SettingInfoCustom, AlertToastService, $window) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.joinMeetingURL = "";
        $ctrl.entity = entity;
        // $ctrl.orderBagItem = {};
        $ctrl.moderatorName = "";
        $ctrl.createMeeting = createMeeting;
        $ctrl.errorMsg = "";
        $ctrl.successMsg = "";
        $ctrl.platformType = '';
        $ctrl.needToCreate = true;
        $ctrl.copyMeetingLink = copyMeetingLink;


        loadAll();
        loadPage();

        function loadAll() {
            $ctrl.orderBagItem = entity.orderBagItem;

            if ($ctrl.orderBagItem.servant) {
                $ctrl.moderatorName = $ctrl.orderBagItem.servant.personInfo.fullName;

                if ($ctrl.orderBagItem.servant.videoCallSettingInfo && $ctrl.orderBagItem.servant.videoCallSettingInfo.id) {
                    getMeetingURLByVideoSetting($ctrl.orderBagItem.servant.videoCallSettingInfo);
                    return;
                }
            }

            SettingInfoCustom.getSettingInfoByCurrentCompany().query().$promise.then(function (setting) {

                if (setting && setting.videoCallSettingInfo) {
                    getMeetingURLByVideoSetting(setting.videoCallSettingInfo);
                }
            })

        }

        function getMeetingURLByVideoSetting(videoCallSetting) {
            if (videoCallSetting && videoCallSetting.platformType) {
                $ctrl.platformType = videoCallSetting.platformType;

                if ($ctrl.platformType == 'JITSI_MEET' ||
                    $ctrl.platformType == 'GOOGLE_MEET' ||
                    $ctrl.platformType == 'SKYPE' ||
                    $ctrl.platformType == 'CUSTOM'
                ) {
                    $ctrl.needToCreate = false;
                    OrderBagServiceItemCustom.getMeetingUrl($ctrl.orderBagItem.id).query().$promise.then(onGetMeetingSuccess, onGetMeetingFailed);

                }
            }
        }

        function onGetMeetingSuccess(result) {

            if (result && result.joinMeetingURL) {
                $ctrl.joinMeetingURL = result.joinMeetingURL;
                // $ctrl.successMsg = "createSuccess";
                $ctrl.errorMsg = "";
            } else {
                onGetMeetingFailed();
            }

        }

        function onGetMeetingFailed() {
            $ctrl.joinMeetingURL = "";
            $ctrl.successMsg = "";
            $ctrl.errorMsg = "linkNotFoundError";
        }


        function createMeeting() {

            getVideoMeetingUrl($ctrl.orderBagItem.id);
        }


        function getVideoMeetingUrl(orderBagItemId) {
            var newMeeting = {};
            newMeeting.orderBagItemId = orderBagItemId;
            newMeeting.password = $ctrl.orderBagItem.servant.id;
            newMeeting.fullName = $ctrl.moderatorName;


            OrderBagServiceItemCustom.createVideoMeeting().save(newMeeting, onCreateMeetingSuccess, onCreateMeetingFailed);

            function onCreateMeetingSuccess(result) {


                if (!result.joinMeetingURL) {
                    $ctrl.joinMeetingURL = result.joinMeetingURL;
                    $ctrl.successMsg = "createSuccess";
                    $ctrl.errorMsg = "";
                } else {
                    onCreateMeetingFailed();
                }

            }

            function onCreateMeetingFailed() {
                $ctrl.joinMeetingURL = "";
                $ctrl.successMsg = "";
                $ctrl.errorMsg = "linkNotFoundError";
            }


        }


        function loadPage() {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();
        }

        function copyMeetingLink() {
            if (!$ctrl.joinMeetingURL) {
                AlertToastService.error('لینک جلسه موجود نیست', null, null);
                return;
            }
            var text = $ctrl.joinMeetingURL;

            var body = angular.element($window.document.body);
            var textarea = angular.element('<textarea/>');
            textarea.css({
                position: 'fixed',
                opacity: '0'
            });

            textarea.val(text);
            body.append(textarea);
            textarea[0].select();
            document.execCommand('copy');
            AlertToastService.success('tikonApp.orderBagServiceItem.videoMeeting.copySuccess', null, null);

            textarea.remove();

        }


    }

    var JoinVideoMeetingComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/join-video-meeting/partial-form.join-video-meeting.html',
        controller: JoinVideoMeetingComponentController,
        bindings:
            {
                orderBagItemId: '=',
                orderBagItem: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfJoinVideoMeeting', JoinVideoMeetingComponent)

    JoinVideoMeetingComponentController.$inject = ['$scope', '$state', '$stateParams', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', 'entity', 'SettingInfoCustom', 'AlertToastService', '$window'];


})();

